import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import { Loader2 } from 'lucide-react';

import { ProcessProvider } from './ProcessContext';
import Landing from './pages/Landing'; // Import the new page
import Dashboard from './Dashboard';
import NewProjectWizard from './NewProjectWizard';
import ProjectWorkspace from './ProjectWorkspace';
import Auth from './pages/AuthPage';
import Paywall from './pages/Paywall';
import Settings from './setting';
import Terms from './TermsOfService';
import Policy from './PrivacyPolicy';
import Links from './trackLinks';


// --- PROTECTED ROUTE WRAPPER ---
const ProtectedRoute = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <Loader2 className="animate-spin text-blue-500 w-10 h-10" />
      </div>
    );
  }

  if (!user) {
    // Redirect to Auth, but save the location they were trying to visit
    return <Navigate to="/auth" state={{ from: location }} />;
  }

  return children;
};

// --- MAIN APP ---
export default function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Landing />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Policy />} />
       <Route path="/pricing" element={<Paywall />} />
 <Route path="/links/:platform" element={<Links />} />

        {/* Protected Routes */}
	<Route                                                   path="/console"
          element={                                                <ProtectedRoute>                                         <Dashboard />
		  </ProtectedRoute>                                    }                                                    />
	  
        <Route 
          path="/console/new" 
          element={
            <ProtectedRoute>
              <NewProjectWizard />
            </ProtectedRoute>
          } 
        />

	  <Route                                                   path="/console/project/:id"
          element={                                                <ProtectedRoute>
              <ProjectWorkspace />                                 </ProtectedRoute>
          }                                                    />
        
        <Route 
          path="/pricing" 
          element={
            <ProtectedRoute>
              <Paywall />
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/settings" 
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          } 
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
